/**
 * @Author: center
 * @Date: 2021/5/19-4:52 下午
 * @Last Modified by: hongweihu
 * @Last Modified time: 2023-10-23 12:50:43
 */
export const GET_COMPANY_INFO = 'company_info/get_company_info';
